import React from "react";

import "./styles.scss";
import ESGChatMain from "../esg-chat/esg-chat";
// import UnSubscribeUI from "../../assets/component/page-errors/un-subscribe";

const CustomResearchMain = ({ isSquarewellUser }) => {
    return (
        <div className="custom-research-main">
            <ESGChatMain searchType="Custom-Internal" showUploadSection />
            {/* {isSquarewellUser ? (
                <ESGChatMain searchType="Custom" />
            ) : (
                <ESGChatMain searchType="Custom-Internal" showUploadSection />
            )} */}
        </div>
    )
}

export default CustomResearchMain